import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { IDynamicItem } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

import { DynamicScope } from '../../interfaces/dynamic-scope';
import { ResolveConfigService } from '../../services/resolve-config.service';

@Component({
  selector: 'epc-dynamic-collections-outlet',
  templateUrl: './dynamic-collections-outlet.component.html',
  styleUrls: ['./dynamic-collections-outlet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DynamicCollectionsOutletComponent implements DynamicScope {
  @Input() public set items(value: IDynamicItem | IDynamicItem[]) {
    const itemsArray = Array.isArray(value) ? value : [value];
    this.resolveConfigService
      .fetchAndMergeConfigEntries(itemsArray)
      .subscribe((resolvedConfig) => {
        this.itemsArray = resolvedConfig;
      });
  }
  @Output() public event = new EventEmitter<unknown>();

  public itemsArray: IDynamicItem[] = [];

  constructor(private readonly resolveConfigService: ResolveConfigService) {}
}
